import type {
  AuthenticationAttemptRequest,
  AuthenticationAttemptResponse,
} from '@/models'
import { HttpErrorService } from '@/services/HttpError.service'
import { authErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'

export class AuthenticationAttemptService {
  private endpoint = '/auth/authentication-attempt'
  private httpErrorService: HttpErrorService<keyof typeof authErrorHandbook>
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      authErrorHandbook,
      'authentication',
    )
  }

  async post(body: AuthenticationAttemptRequest) {
    return await this.httpService
      .post<AuthenticationAttemptResponse>(this.endpoint, {
        fetchConfig: {
          body: { ...body },
        },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(
          error,
          this.endpoint,
          'authentication',
        )
      })
  }
}
